import React from "react";
import { columnCellGeneratorType, columnsVisibleType, resultRowType } from "../../../../common/types/search/results";
import { footnotesType } from "../../../../common/types/search/search";

interface SearchResultsRowProps {
	additionalClasses?: string;
	item: resultRowType;
	columnsVisible: columnsVisibleType;
	footnotes?: footnotesType;
	columnCellGenerator: columnCellGeneratorType;
}

export function SearchResultsRow({
	additionalClasses,
	item,
	columnsVisible,
	footnotes,
	columnCellGenerator,
}: SearchResultsRowProps) {
	return (
		<tr className={additionalClasses}>
			{columnCellGenerator(columnsVisible, item, footnotes)}
		</tr>
	);
}
